import styled from 'styled-components'

import { Button, WorkspaceLogo } from '@sketch/components'
import { ReactComponent as DotsIcon } from '@sketch/icons/dots-3-horizontal-24-svg'

export const HeaderButton = styled(Button).attrs({
  size: '32',
  variant: 'secondary',
})`
  height: 40px;
`

export const SharingButton = styled(HeaderButton)`
  padding: 7px 12px 7px 7px; /* stylelint-disable-line scales/space */
  margin-right: 16px;

  ${WorkspaceLogo}, ${WorkspaceLogo.Icon} {
    margin-right: 8px;
  }

  ${WorkspaceLogo.Icon} {
    border: 1px solid ${({ theme }) => theme.colors.border.A};
    color: ${({ theme }) => theme.colors.foreground.secondary.C};
  }
`

export const Dots = styled(DotsIcon)`
  width: 24px;
  height: 24px;
`

export const ButtonWrapper = styled.div`
  display: flex;
`

export const TextWrapper = styled.div`
  line-height: 1;
  margin-left: 12px;
`
